import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactFileReader from 'react-file-reader';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { Button } from '../../../components/index.js';
import labConstants from '../Lab.constants';
import * as XLSX from 'xlsx';

class Upload extends Component {
  parseWorkbookRows = fileObj => (
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = event => {
        try {
          const data = event.target.result;
          const workbook = XLSX.read(data, { type: 'array' });
          const firstSheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[firstSheetName];
          const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, raw: true });
          resolve(rows || []);
        } catch (error) {
          reject(error);
        }
      };
      reader.onerror = () => reject(reader.error);
      reader.readAsArrayBuffer(fileObj);
    })
  );

  handleFiles = files => {
    if (files.fileList[0].name.indexOf('xlsx') !== -1) {
      let fileObj = files.fileList[0];
      const { onUpdate } = this.props;
      this.parseWorkbookRows(fileObj).then(lines => {
        let keys = lines[0];
        const jsonArr = [];
        let json = {};
        if (
          keys.length === 8 &&
          (keys[0] === 'Chemical Class' || keys[0] === 'chemicalClass') &&
          (keys[1] === 'Chemical Name' || keys[1] === 'chemicalName') &&
          (keys[2] === 'CAS Number' || keys[2] === 'CAS') &&
          (keys[3] === 'Required Laboratory Reporting Limit' || keys[3] === 'labLimit') &&
          (keys[4] === 'Nike Limit' || keys[4] === 'nikeLimit') &&
          (keys[5] === 'Test Result' || keys[5] === 'testResultValue') &&
          (keys[6] === 'Unit' || keys[6] === 'unit') &&
          (keys[7] === 'Specific Limit' || keys[7] === 'specificLimit')
        ) {
          keys = ['chemicalClass', 'chemicalName', 'CAS', 'labLimit', 'nikeLimit', 'testResultValue', 'unit', 'specificLimit'];
          for (let lineCount = 0; lineCount < lines.length; lineCount++) {
            const lineData = lines[lineCount];
            if (lineCount !== 0) {
              json = {};
              const columns = [0, 1, 2, 3, 4, 5, 6, 7];
              for (let j = 0; j < keys.length; j++) {
                json[keys[j]] = lineData[columns[j]];
              }
              jsonArr.push(json);
            }
          }
        }
        onUpdate(jsonArr);
      }).catch(() => {
        toast.error(labConstants.invalidFile_msg, {
          position: 'top-center',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        });
      });
    } else {
      toast.error(labConstants.invalidFile_msg, {
        position: 'top-center',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
    }
  };

  render() {
    return (
      <div>
        <ReactFileReader fileTypes={['.xlsx']} base64 multipleFiles={false} handleFiles={this.handleFiles}>
          <span className="download-section upload">
            <i className="fas fa-upload" />
            <Button className="text-color-accent download-button">UPLOAD</Button>
          </span>
        </ReactFileReader>
      </div>
    );
  }
}
Upload.propTypes = {
  onUpdate: PropTypes.func
};

export default connect()(Upload);
